import type React from 'react';
import { useState } from 'react';
import Table from 'antd/lib/table';
import type { SerializedCreditInvoice } from '@enmon/commons/lib/enmon';
import type { PopulatedSerializedCreditInvoice } from 'lib/services';
import { ResellerCreditsModal } from './Modal';
import { useCreditInvoices } from '../hooks/useCreditInvoices';
import { getColumns } from '../utils/getColumns';
import { useDeleteCreditInvoice } from '../hooks/useDeleteCreditInvoice';
import { useFilterWithPagination } from '../useFilterWithPagination';

export const ResellerCreditsTable: React.VFC = () => {
  const { filter, pagination } = useFilterWithPagination();

  const { data: { result: creditInvoices, count: total } = {}, isFetching: isGetting } = useCreditInvoices(filter);

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const handleModalHide = () => {
    setIsModalVisible(false);
  };

  const { mutate: deleteCreditInvoice, isLoading: isDeleting } = useDeleteCreditInvoice();

  const [editedCreditInvoiceId, setEditedCreditInvoiceId] = useState<SerializedCreditInvoice['_id']>(undefined);

  const handleDelete = (id: SerializedCreditInvoice['_id']) => {
    deleteCreditInvoice(id);
  };

  const handleEdit = (item: PopulatedSerializedCreditInvoice) => {
    setEditedCreditInvoiceId(item._id);
    setIsModalVisible(true);
  };

  const columns = getColumns(handleEdit, handleDelete);

  return (
    <>
      {isModalVisible && (
        <ResellerCreditsModal
          creditInvoice={creditInvoices?.find(credit => credit._id === editedCreditInvoiceId)}
          onHide={handleModalHide}
        />
      )}
      <Table
        columns={columns}
        dataSource={creditInvoices}
        loading={isGetting || isDeleting}
        pagination={{
          ...pagination,
          total: total ?? 0,
          showTotal: (currentTotal, range) => `${range[0]}-${range[1]} of ${currentTotal} credit invoices`,
        }}
        rowKey={row => row._id}
        scroll={{ x: true }}
      />
    </>
  );
};
